


















































































import {
  Vue,
  Component
} from "@/shared/vuepack";
import Moment from "moment";
import { openUrl, getRoutePath } from "@/shared/urlHelper";
import {
  UserEventKey,
  UserEventType,
  HsabAccountNametag,
  CommunicationDashboard
} from "@/shared/types";
import { planTypeIconMap } from "@/shared/awesomeIconMapper";
import { formatMMMDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useUserStore } from "@/shared/store/user";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCommunicationStore } from "@/shared/store/communication";


@Component({ components: { SsoDeepLink } })
export default class HsabNotionalDashboard extends Vue {
  planTypeIconMap = planTypeIconMap;
  formatMMMDateString = formatMMMDateString;
  moment = Moment;
  formatCurrency = formatCurrency;

  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  communicationStore = useCommunicationStore();

  isLoading = false;

  mounted (): void {
    this.hsabAccountsStore.getHsabAccounts().then(() => this.communicationStore.loadEmployeeCommunications({
      planTypes: this.hsabAccountsStore.planTypes,
      dashboard: CommunicationDashboard.Notional
    }));
  }

  get fieldConfiguration () {
    return [
      { key: "account", label: "ACCOUNT", tdClass: "align-middle" },
      { key: "planYearDates", label: "PLAN YEAR DATES", tdClass: "align-middle" },
      {
        key: "planFilingDates", label: "PLAN FILING DATES", tdClass: "align-middle",
        tooltip: "The final service date is the last day on which eligible expenses can be incurred and reimbursed using the funds in the account. After the final service date, all eligible expenses must be submitted manually prior to the final filing date."
      },
      { key: "balance", label: "BALANCE", tdClass: "align-middle" },
      { key: "actions", label: "", tdClass: "text-center" },
    ];
  }

  onClick (account: HsabAccountNametag) {
    this.hsabAccountsStore.navigateToAccountPage(account);
  }

  handleActionLinkClick (v: any) {
    const r: any = this.communicationStore.communications.filter(x => x.id === v)[0];
    if (r.isActionLinkExternal) {
      openUrl(r.actionLink);
    } else {
      this.$router.push(getRoutePath(r.actionLink));
    }
    this.userStore.saveUserEvent({
      eventType: UserEventType.PartnerCommunicationWidgetClick,
      values: [
        { key: UserEventKey.PartnerCommunicationId, value: r.id },
        { key: UserEventKey.PartnerCommunicationSubject, value: r.subject },
        { key: UserEventKey.PartnerCommunicationLocation, value: "employee" }
      ]
    });
  }
}
